import React from 'react';
import styles from './ProjectsDashboardHeader.module.scss';

export interface ProjectsDashboardHeaderProps {}

export const ProjectsDashboardHeader = (
  props: ProjectsDashboardHeaderProps
): React.ReactElement<ProjectsDashboardHeaderProps> => {
  return (
    <div className={styles.projectsDashboardHeader}>
      <h2 className={styles.title}>Projects</h2>
    </div>
  );
};
